import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Link from 'Component/Link';
import { ProductAttributeValue as SourceProductAttributeValue } from 'SourceComponent/ProductAttributeValue/ProductAttributeValue.component';
import { ProductType } from 'Type/ProductList.type';
import fromCache from 'Util/Cache/Cache';
import { getProductInStock } from 'Util/Product/Extract';
import getStore from 'Util/Store';

import { STRING_ONLY_ATTRIBUTE_CODES } from './ProductAttributeValue.config';

import './ProductAttributeValue.override.style';

/** @namespace Elganso/Component/ProductAttributeValue/Component */
export class ProductAttributeValueComponent extends SourceProductAttributeValue {
    static propTypes = {
        ...this.propTypes,
        isFilterOverlay: PropTypes.bool.isRequired,
        product: ProductType,
        threshold_qty: PropTypes.number
    };

    static defaultProps = {
        ...this.defaultProps,
        isFilterOverlay: false,
        product: {},
        threshold_qty: getStore().getState().ConfigReducer.threshold_qty
    };

    getVariantItem() {
        const { product, attribute: { attribute_value }, YBParameters } = this.props;
        const attributeOption = this.getOptionLabel(attribute_value);
        let variantItem = [];

        if (product?.id) {
            if (product.configurable_options?.color && YBParameters?.color) {
                const product_colors = Object.keys(product.configurable_options.color.attribute_options);

                // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
                if (product_colors.find((e) => e === YBParameters.color)) {
                    variantItem = product?.variants.find((obj) => (obj.attributes.color.attribute_value === YBParameters.color) && (obj.attributes.size.attribute_value === attributeOption.value));
                } else {
                    variantItem = product?.variants.find((obj) => (obj.attributes.color.attribute_value === product_colors[0]) && (obj.attributes.size.attribute_value === attributeOption.value));
                }
            } else {
                variantItem = product?.variants.find((obj) => obj?.sku === `${ product?.sku }-${ attributeOption.label }`);
            }
        }

        return variantItem;
    }

    renderDropdown(value, subLabel) {
        const { isSelected } = this.props;

        return (
            <Field
              type={ FIELD_TYPE.checkbox }
              attr={ {
                id: value,
                  name: value
              } }
              label={ this.getCheckboxLabel(value, subLabel) }
              mix={ {
                  block: 'ProductAttributeValue',
                  elem: 'Text',
                  mods: { isSelected }
              } }
            />
        );
    }

    renderStringValue(value, label, count) {
        const {
            isFormattedAsText, isSelected, threshold_qty, isAvailable, product
        } = this.props;
        const isSwatch = label;
        const variantItem = this.getVariantItem();
        const isPreOrder = variantItem?.preorder === 1;
        let isBajoStock = false;
        let isNotAvailable = !isAvailable;

        if (product.type_id === 'configurable' && product.variants) {
            isNotAvailable = !this.isSizeAvailable();
        }

        if (isFormattedAsText) {
            return label || value || __('N/A');
        }

        if (!isSwatch) {
            return this.renderDropdown(value, count);
        }

        if (isNotAvailable) {
            label = isNotAvailable ? __('Receive Notice') : label;
        } else if (isPreOrder) {
            label = isPreOrder ? __('Preorder') : label;
        } else if (variantItem?.salable_qty <= threshold_qty && variantItem?.salable_qty != null) {
            isBajoStock = true;
            label = __('Last Units!');
        }

        let data_sku = '';
        if(variantItem?.sku){
            data_sku = variantItem.sku;
        }

        if (isPreOrder || isBajoStock || isNotAvailable) {
            return (
                <span
                  block="ProductAttributeValue"
                  elem="String"
                  mods={ {
                    isSelected, isPreOrder, isBajoStock, isNotAvailable
                  } }
                  data-title={ label }
                  data-product-sku={ data_sku }
                >
                    { value }
                </span>
            );
        }

        return (
            <span
              block="ProductAttributeValue"
              elem="String"
              mods={ { isSelected } }
              data-product-sku={ data_sku }
            >
                { value }
            </span>
        );
    }

    clickHandler(e) {
        const { onClick, attribute } = this.props;

        e.preventDefault();
        e.stopPropagation();

        onClick(attribute);
    }

    renderSelectAttribute() {
        const { attribute: { attribute_value, attribute_code, has_swatch } } = this.props;
        const attributeOption = this.getOptionLabel(attribute_value);
        const {
            label, labelText, count, swatch_data, value_string
        } = attributeOption;

        // skip attributes without valid swatches
        if (!swatch_data && has_swatch) {
            if (attribute_code === 'size') {
                return this.renderStringValue(labelText, labelText, count);
            }

            if (attribute_code === 'color') {
                let listProducts = getStore().getState().ProductListReducer.pages;
                let actualColor = '';

                if (Object.keys(listProducts).length !== 0) {
                    listProducts = Object.values(listProducts);

                    listProducts.some((productArray) => {
                        productArray.some((product) => {
                            if (product?.type_id === 'configurable') {
                                if (product?.attributes?.color?.attribute_options[value_string]) {
                                    actualColor = product.attributes.color.attribute_options[value_string].swatch_data.value;

                                    return true;
                                }
                            }
                        });
                    });
                }

                return this.renderColorValue(actualColor, labelText);
            }

            return null;
        }

        if (!swatch_data || STRING_ONLY_ATTRIBUTE_CODES.includes(attribute_code)) {
            return this.renderStringValue(labelText || __('N/A'), null, count);
        }

        const { value, type } = swatch_data;

        switch (type) {
            case '0':
                return this.renderStringValue(value, labelText, count);
            case '1':
                return this.renderColorValue(value, labelText);
            case '2':
                return this.renderImageValue(value, label);
            default:
                return this.renderStringValue(labelText || __('N/A'), labelText, count);
        }
    }

    renderColorValue(color, label) {
        const { isFormattedAsText, isSelected, isFilterOverlay } = this.props;
        const isLight = this.getIsColorLight(color);

        if (isFormattedAsText) {
            return label || __('N/A');
        }

        const style = {
            '--option-background-color': color,
            '--option-border-color': isLight ? '#606060' : color,
            '--option-check-mark-background': isLight ? '#000' : '#fff',
            // stylelint-disable-next-line value-keyword-case
            '--option-is-selected': isSelected ? 1 : 0
        };

        if (isFilterOverlay) {
            const styleFilter = {
                '--option-background-color': color,
                '--option-border-color': isLight ? '#606060' : color
            };

            return (
                <div block="ProductAttributeValue" elem="FilterOverlay">
                    <data
                      block="ProductAttributeValue"
                      elem="Color"
                      mods={ { isFilterOverlay } }
                      value={ label }
                      title={ label }
                      style={ styleFilter }
                    />
                    <div block="ProductAttributeValue" elem="title">{ label }</div>
                </div>
            );
        }

        return (
            <data
              block="ProductAttributeValue"
              elem="Color"
              mods={ { isFilterOverlay } }
              value={ label }
              title={ label }
              style={ style }
            />
        );
    }

    isSizeAvailable() {
        const {
            attribute,
            attribute: { attribute_value },
            product,
            YBParameters
        } = this.props;

        let productVariant = null;

        const size = attribute.attribute_options[attribute_value].label;

        if (product.configurable_options.color) {
            const product_colors = Object.keys(product.configurable_options.color.attribute_options);

            if (product.configurable_options?.color?.attribute_value !== null) {
                const productSku = product?.variants.find((obj) => obj.attributes.color.attribute_value === product.configurable_options.color.attribute_value);
                productVariant = product?.variants.find((obj) => obj?.sku === `${ productSku?.sku.split('-')[0] }-${ size }`);
            } else {
                const attributeOption = this.getOptionLabel(attribute_value);

                // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
                if (product_colors.find((e) => e === YBParameters.color)) {
                    productVariant = product?.variants.find((obj) => (obj.attributes.color.attribute_value === YBParameters.color) && (obj.attributes.size.attribute_value === attributeOption.value));
                } else {
                    productVariant = product?.variants.find((obj) => (obj.attributes.color.attribute_value === product_colors[0]) && (obj.attributes.size.attribute_value === attributeOption.value));
                }
            }
        } else {
            productVariant = product?.variants.find((obj) => obj?.sku === `${ product?.sku }-${ size }`);
        }
        if (!productVariant) {
            return true;
        }

        return fromCache(getProductInStock, [productVariant, product]);
    }

    getIsColorLight(hex) {
        if (hex != null) {
            const color = (hex.charAt(0) === '#') ? hex.substring(1, 7) : hex;
            const r = parseInt(color.substring(0, 2), 16); // hexToR
            const g = parseInt(color.substring(2, 4), 16); // hexToG
            const b = parseInt(color.substring(4, 6), 16); // hexToB

            return ((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186;
        }

        return false;
    }

    render() {
        const {
            getLink,
            attribute,
            isAvailable,
            attribute: { attribute_code, attribute_value },
            mix,
            isFormattedAsText,
            showProductAttributeAsLink,
            isSelected,
            product
        } = this.props;

        if (attribute_code && !attribute_value) {
            return null;
        }

        const href = getLink(attribute);
        // Invert to apply css rule without using not()
        let isNotAvailable = !isAvailable;

        if (isFormattedAsText) {
            return (
                <div
                  block="ProductAttributeValue"
                  mix={ mix }
                >
                    { this.renderAttributeByType() }
                </div>
            );
        }

        if (!showProductAttributeAsLink) {
            if (attribute_code === 'color') {
                return (
                    <span
                      block="ProductAttributeValue"
                      mods={ { isNotAvailable } }
                      onClick={ this.clickHandler }
                      onKeyDown={ this.clickHandler }
                      role="link"
                      tabIndex="-1"
                      aria-hidden={ false }
                      mix={ mix }
                    >
                    { this.renderAttributeByType() }
                    </span>
                );
            }

            if (product.type_id === 'configurable' && product.variants) {
                isNotAvailable = !this.isSizeAvailable();
            }

            return (
                <span
                  block="ProductAttributeValue"
                  mods={ { isNotAvailable } }
                  onClick={ this.clickHandler }
                  onKeyDown={ this.clickHandler }
                  role="link"
                  tabIndex="-1"
                  aria-hidden={ false }
                  mix={ mix }
                >
                    { this.renderAttributeByType() }
                    <FontAwesomeIcon
                      className="faEnvelope"
                      icon={ faEnvelope }
                    />
                </span>
            );
        }

        return (
            <Link
              to={ href }
              block="ProductAttributeValue"
              mods={ { isNotAvailable, isSelected } }
              onClick={ this.clickHandler }
              aria-hidden={ isNotAvailable }
              mix={ mix }
            >
                { this.renderAttributeByType() }
            </Link>
        );
    }
}

export default ProductAttributeValueComponent;
